<template>
  <div class="container-fluid">
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranch"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="form.branch_id">
                  <label for="Type">Type</label>
                  <select
                    v-model="form.planType"
                    name="planType"
                    @change="getPlanType"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('planType'),
                    }"
                    required
                  >
                    <option v-if="!form.planType" selected value="">
                      Select plan Type
                    </option>
                    <option value="group">Group</option>
                    <option value="individual">Individual</option>
                  </select>
                  <has-error
                    :form="form"
                    field="planType"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="form.planType === 'group'">
                  <label for="Group">Group</label>
                  <v-select v-model="collectionCenter" name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Branch" v-on:input="getMembers">
                    
                  </v-select>
                  
                  <has-error
                    :form="form"
                    field="collection_center_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="date">Date</label>
                  <input type="date" v-model="emiDate" name="emiDate" class="form-control" @change="getEMIRecord" placeholder="EMI Date">
                </div>
                <!-- <div class="col-md-6" v-if="this.emiDate">
                  <label for="Member">Members</label>
                  
                  <select v-model="form.member_loan_plan_id"  name="member_loan_plan_id"  class="form-control" @change="getSingleMemberLoanDetails"
                    :class="{'is-invalid': form.errors.has('member_loan_plan_id')}"  required>
                    <option v-if="!form.member_loan_plan_id" selected value="">Select Member</option>
                    <option  :value="memberloanplan.member_loan_plan_id"  v-for="memberloanplan in memberloanplans"  :key="memberloanplan.id">
                    ({{memberloanplan.member_loan_plan.applicationNo}}) - ( {{ memberloanplan.member.code }}  {{ memberloanplan.member.name }} ) - ( <span v-if="memberloanplan.collection_center"> {{ memberloanplan.collection_center.centerCode}} {{ memberloanplan.collection_center.name}} </span> {{memberloanplan.type}} )
                    </option>
                  </select>
                </div> -->
                <div class="col-md-6">
                  <label for="Member">Members</label>
                  <!-- <v-select v-model="memberloanplan" name="member_id" label="member" :options="memberloanplans" placeholder="Select Member" v-on:input="getMember"></v-select> -->
                  <!-- <select v-model="form.member_loan_plan_id"  name="member_loan_plan_id"  class="form-control" @change="getSingleMemberLoanDetails"
                    :class="{'is-invalid': form.errors.has('member_loan_plan_id')}"  required>
                    <option v-if="!form.member_loan_plan_id" selected value="">Select Member</option>
                    <option  :value="memberloanplan.id"  v-for="memberloanplan in memberloanplans"  :key="memberloanplan.id">
                    ({{memberloanplan.applicationNo}}) - ( {{ memberloanplan.member.code }}  {{ memberloanplan.member.name }} ) - ( <span v-if="memberloanplan.collection_center">  {{ memberloanplan.collection_center.centerCode}} {{ memberloanplan.collection_center.name}} </span> {{memberloanplan.type}} )
                    </option>
                  </select> -->
                  <v-select v-model="mem"  name="member_id" label="name" :options="memberloanplans" placeholder="Select Member" v-on:input="getSingleMemberLoanDetails">
                          
                  </v-select>
                  <has-error
                    :form="form"
                    field="member_id"
                  ></has-error>
                  <has-error :form="form" field="member_id"></has-error>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="box box-danger">
            <div class="box-header with-border">
              <h3 class="box-title">Get Single Member Record</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-2">
                  <!-- <label for="ApplicationNumber">Application Number</label> -->
                  <input type="text" v-model="applicationNumber" name="applicationNumber" class="form-control" placeholder="Application Number">
                  <input type="button" value="Submit" @click="getLoanDetailsApplicationNumber" class="btn btn-success btn-sm">
                </div>
                <!-- <div class="col-md-2">
                  <input type="text" v-model="memberCode" name="memberCode" class="form-control" placeholder="Member Code">
                  <input type="button" name="submit" value="Submit" @click="getLoanDetailsMemberCode" class="btn btn-success btn-sm">
                </div> -->
                <!-- <div class="col-md-2">
                  <input type="text" class="form-control" placeholder="Mobile Number">
                  <input type="submit" name="submit" value="Submit" class="btn btn-success btn-sm">
                </div> -->
                <!-- <div class="col-md-3">
                  <input type="text" class="form-control" placeholder="AdharCard Number">
                  <input type="submit" name="submit" value="Submit" class="btn btn-success btn-sm">
                </div> -->
                <!-- <div class="col-md-3">
                  <input type="text" class="form-control" placeholder="Pancard Number">
                  <input type="submit" name="submit" value="Submit" class="btn btn-success btn-sm">
                </div> -->
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.card -->
          <div class="box box-success">
            <div class="box-body">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right">
                    
                  </span>
                  <h3 class="card-title">Member Collection</h3>
                  <p >
                    <strong class="text-danger">Status: {{ memberloanplan.status }}</strong><br>
                    <strong class="text-success">Received Amount: {{ memberloanplan.receivedAmt }}</strong>
                  </p>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columnsMemberCollections"
                    :rows="rowsMemberCollections"
                    styleClass="vgt-table condensed"
                    :line-numbers="true"
                    :pagination-options="{
                      enabled: true,
                      perPage: 10,
                      perPageDropdown: [10, 20, 30],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'paymentdate'">
                        <span>{{props.row.paymentDate | myDate }}</span>
                      </span>
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'approved'"
                          class="label label-success"
                          >Approved</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                      </span>
                      
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
          </div>                                                      
          <div class="box box-info" v-if="form.member_loan_plan_id">
            <div class="box-body">
              <div class="card" v-if="form.member_loan_plan_id">
                <div class="card-header">
                  <span class="pull-right">
                    <button type="button" class="btn btn-sm float-right" @click="paywithpaytm">
                     <img src="../../assets/paytm.png" width=50> <br>
                     <small>Pay with Paytm</small>
                    </button>
                    <button type="button" class="btn btn-success btn-sm" @click="newModal">
                      <i class="fa fa-money"> Collect Payment</i>
                    </button>
                  </span><br>
                  <h3 class="card-title">Total EMI</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 10,
                      perPageDropdown: [10, 20, 30],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'emidate'">
                        <span>{{props.row.emiDate | myDate }}</span>
                      </span>
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning xs"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'sattle'"
                          class="label label-primary xs"
                          >Settle</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success xs"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info xs"
                          >Partial</span
                        >
                      </span>
                      
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
            </div>
          </div>
          
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
      <div class="modal fade" id="paywithpaytm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Collection Details</h4>
            </div>
            <form @submit.prevent="collectPaytmPayment()">
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <input
                              type="hidden"
                              name="branch_id"
                              v-model="memberloanplan.branch_id"
                            />
                          <input
                              type="hidden"
                              name="member_loan_plan_id"
                              v-model="memberloanplan.id"
                            />
                          <input
                              type="hidden"
                              name="member_id"
                              v-model="memberloanplan.member_id"
                            />
                          <input
                              type="hidden"
                              name="disbursement_id"
                              v-model="memberloanplan.disbursement_id"
                            />
                          <input
                              type="hidden"
                              name="collection_center_id"
                              v-model="memberloanplan.collection_center_id"
                            />
                           <div class="form-group">
                            <label>Name <span class="red">*</span></label>
                            <input
                              v-model="form.name"
                              type="text"
                              name="name"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('name') }"
                              required
                            />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Mobile <span class="red">*</span></label>
                            <input
                              v-model="form.mobile"
                              type="text"
                              name="mobile"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('mobile') }"
                              required
                            />
                            <has-error :form="form" field="mobile"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Email <span class="red">*</span></label>
                            <input
                              v-model="form.email"
                              type="text"
                              name="email"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('email') }"
                              required
                            />
                            <has-error :form="form" field="email"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Amount <span class="red">*</span></label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('amt') }"
                              required
                            />
                            <has-error :form="form" field="amt"></has-error>
                          </div>
                        </div>
                        <!-- <div class="col-md-6">
                          <div class="box box-default" v-if="memberloanplan.member">
                            <div class="box-header with-border">
                              <i class="fa fa-bullhorn"></i> 
                              <h3 class="box-title">Customer Details</h3>
                            </div> 
                            <div class="box-body">
                               
                              <div class="callout callout-info">
                                <h4>Member</h4>
                                <p>{{memberloanplan.member.name}}</p>
                              </div>
                              <div class="callout callout-warning">
                                <h4>Branch</h4> 
                                <p>{{memberloanplan.branch.name}}</p>
                              </div> 
                              <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                                <h4>Group</h4>
                                <p>{{memberloanplan.collection_center.name}}</p>
                              </div>
                            </div>
                          </div>
                          
                        </div> -->
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  Pay Now
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
            <form id="paytmForm" method="POST" :action="`${$axios.defaults.baseURL}/paytm/payment`">
              <input v-for="(input, index) in form" :key="index" type="hidden" :name="index" :value="input">
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

<!-- /.row -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Payment Collection</h4>
            </div>
            <form @submit.prevent="collectPayment()">
              <div class="modal-body">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group" v-if="plCategory === 'interest'">
                          <label
                            >Select Payment Type <span class="red">*</span></label
                          >
                          <select
                            v-model="form.collectionType"
                            name="form.collectionType"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('form.collectionType'),
                            }"
                          >
                            <option v-if="!form.collectionType" selected value="">
                              Select Payment Type
                            </option>
                            <option value="interest">Interest</option>
                            <option value="loan">Principal</option>
                          </select>
                          <has-error :form="form" field="form.collectionType"></has-error>
                        </div>
                        <input
                          type="hidden"
                          name="branch_id"
                          v-model="memberloanplan.branch_id"
                        />
                        <input
                          type="hidden"
                          name="member_loan_plan_id"
                          v-model="memberloanplan.id"
                        />
                        <input
                          type="hidden"
                          name="member_id"
                          v-model="memberloanplan.member_id"
                        />
                        <input
                          type="hidden"
                          name="disbursement_id"
                          v-model="memberloanplan.disbursement_id"
                        />
                        <input
                          type="hidden"
                          name="collection_center_id"
                          v-model="memberloanplan.collection_center_id"
                        />
                        <div class="form-group">
                          <label>Amount <span class="red">*</span></label>
                          <input
                            v-model="form.amt"
                            type="text"
                            name="amt"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('amt') }"
                            required
                          />
                          <has-error :form="form" field="amt"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Select Ledger Account </label>
                          <select
                            v-model="form.branch_ledger_id"
                            name="branch_ledger_id"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('branch_ledger_id'),
                            }"
                          >
                            <option v-if="!form.branch_ledger_id" selected value="">
                              Select Ledger Account
                            </option>
                            <option
                              :value="bank_account.id"
                              v-for="bank_account in bank_accounts"
                              :key="bank_account.id"
                            >
                              {{bank_account.name}} {{bank_account.remark}}
                            </option>
                          </select>
                          <has-error :form="form" field="branch_ledger_id"></has-error>
                        </div>
                        <div class="form-group">
                        <label
                          >Payment Date <span class="red">*</span></label
                          >
                          <input
                            v-model="form.paymentDate"
                            type="date"
                            name="paymentDate"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('paymentDate'),
                            }"
                            required
                          />
                          <has-error
                            :form="form"
                            field="paymentDate"
                          ></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Attendance <span class="red">*</span></label
                          >
                          <select
                            v-model="form.attendance"
                            name="attendance"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('attendance'),
                            }"
                          >
                            <option selected value="present">Present</option>
                            <option value="absent">Absent</option>
                          </select>
                          <has-error :form="form" field="attendance"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Remark </label>
                          <input
                            v-model="form.remark"
                            type="text"
                            name="remark"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('remark') }"
                          />
                          <has-error :form="form" field="remark"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="box box-default" v-if="memberloanplan.member">
                          <div class="box-header with-border">
                            <i class="fa fa-bullhorn"></i> 
                            <h3 class="box-title">Customer Details</h3>
                          </div> 
                          <div class="box-body">
                              
                            <div class="callout callout-info">
                              <h4>Member</h4>
                              <p>{{memberloanplan.member.name}}</p>
                            </div>
                            <div class="callout callout-warning">
                              <h4>Branch</h4> 
                              <p>{{memberloanplan.branch.name}}</p>
                            </div> 
                            <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                              <h4>Group</h4>
                              <p>{{memberloanplan.collection_center.name}}</p>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Loan Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr>
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfIntrest }}
                              </td>
                              <td>
                                <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td>
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_loan_plan_id">
                          <b>Member Id</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewGroupMember">
        <div class="modal-dialog modal-md">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Group Member Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Code</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="groupMem in groupMembers"
                              :key="groupMem.id"
                            >
                              <td>
                                <a>{{ groupMem.member.name }}</a>
                              </td>
                              <td>
                                <a> {{ groupMem.member.code }}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
import { mapState } from 'vuex'
export default {
  name: 'MemberCollection',
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      editMode: false,
      emiDate: null,
      mem: {},
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      plCategory: '',
      branches: [],
      branch: {},
      members: {},
      staffs: {},
      banks: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      bank_accounts: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      loadDisbursements: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        name: '',
        mobile: '',
        email: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        planType: '',
        attendance: '',
        collectionType: '',
        remark: '',
        type: 'emi',
        member_id: '',
        status: '',
        disbursement_id: '',
        branch_ledger_id: '',
        paymentDate: new Date().toISOString().slice(0, 10),
        emiStartDate: '',
        receivedBy: JSON.parse(localStorage.user).id
      }),
      columns: [
        {
          label: 'EMI DATE',
          field: 'emidate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARRIER',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: [],
      columnsMemberCollections: [
        {
          label: 'PAYMENT DATE',
          field: 'paymentdate'
        },
        {
          label: 'AMOUNT',
          field: 'amt'
        },
        {
          label: 'TYPE',
          field: 'type'
        },
        {
          label: 'RECEIVED BY',
          field: 'received_by.name'
        },
        {
          label: 'PAYMENT MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rowsMemberCollections: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.$axios
        .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      $('#newModal').modal({backdrop: 'static', keyboard: false})
     // this.loadDisbursement()
    },
    paywithpaytm () {
      this.form.name = this.memberloanplan.member.name
      this.form.mobile = this.memberloanplan.member.mobile
      this.form.email = this.memberloanplan.member.email
      $('#paywithpaytm').modal({backdrop: 'static', keyboard: false})
    },
    getBranch () {
      this.form.branch_id = this.branch.id
      this.form.collection_center_id = ''
      this.form.planType = ''
      this.memberloanplans = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      this.rows = []
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
    },
    getMembers () {
      this.memberloanplans = []
      this.form.member_loan_plan_id = ''
      this.rows = []
      this.rowsMemberCollections = []
      this.form.collection_center_id = this.collectionCenter.id
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
    },
    getEMIRecord () {
      this.memberloanplans = []
      this.memberloanplan = {}
      this.mem = {}
      this.rows = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      if (this.emiDate) {
        this.$axios
        .get('memberemi?all=all&emiDate=' + this.emiDate + '&branch_id=' + this.form.branch_id + '&type=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
          _.forEach(this.memberloanplans, function (item, key) {
            this.memberloanplans[key].name = item.member.name + ' (' + item.member.code + ')' + '( Application Number - ' + item.member_loan_plan.applicationNo + ')'
            // if (this.form.member_id === item.member.id) {
            //   this.mem = item
            // }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.getMemberLoanPlan()
      }
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      this.form.member_loan_plan_id = null
      return pln.name
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewGroupMember (id) {
      this.loadGroupMember(id)
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    getSingleMemberLoanDetails () {
      this.plCategory = ''
      this.form.collectionType = ''
      if (this.emiDate) {
        this.form.member_loan_plan_id = this.mem.member_loan_plan_id
        this.memberloanplan = this.mem
        if (this.memberloanplan) {
          this.plCategory = this.memberloanplan.disbursement.planCategory
          this.form.branch_id = this.memberloanplan.branch_id
          if (this.memberloanplan.disbursement) {
            if (this.memberloanplan.disbursement.planType === 'group') {
              this.form.collection_center_id = this.memberloanplan.disbursement.collection_center_id
            }
          }
        }
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.plCategory = this.mem.disbursement.planCategory
        this.form.member_loan_plan_id = this.mem.id
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('record without date')
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      this.$axios
        .get('membercollection?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      var ss = this.form.member_loan_plan_id
      if (this.memberloanplans.length >= 1) {
        // console.log('hhhhhhhhh')
        // console.log(this.memberloanplans)
        // console.log(ss)
        if (!this.emiDate) {
          this.memberloanplan = _.find(this.memberloanplans, function (o) { return o.id === ss })
        }
        // console.log(this.memberloanplan)
      }
      this.form.member_id = this.mem.member_id
      this.form.disbursement_id = this.mem.disbursement_id
      if (this.form.planType === 'group') {
        if (this.form.collection_center_id === '' || this.form.collection_center_id === null) {
          this.form.collection_center_id = this.mem.collection_center_id
        }
      }
    },
    createLoan () {
      this.$axios
        .post('createloan', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Create New Loan Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    collectPaytmPayment () {
      this.form.branch_id = this.memberloanplan.branch_id
      this.form.member_id = this.memberloanplan.member_id
      this.form.disbursement_id = this.memberloanplan.disbursement_id
      this.form.member_loan_plan_id = this.memberloanplan.id
      this.form.mode = 'paytm'
      $('#paytmForm').submit()
    },
    collectPayment () {
      if (this.memberloanplan.type === 'individual') {
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Payment Collect Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getMemberLoanPlan () {
      this.memberloanplans = []
      this.mem = {}
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.memberloanplans = data.data
          _.forEach(this.memberloanplans, function (item, key) {
            this.memberloanplans[key].name = item.member.name + ' (' + item.member.code + ')' + '( Application Number - ' + item.applicationNo + ')'
            // if (this.form.member_id === item.member.id) {
            //   this.mem = item
            // }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsApplicationNumber () {
      this.plCategory = ''
      this.form.collectionType = ''
      this.form.member_loan_plan_id = []
      this.rows = []
      this.rowsMemberCollections = []
      this.$axios
      .get('memberloanplan?all=all&searchTerm=' + this.applicationNumber, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.$axios
        .get('memberloanplan/' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // alert(data)
          console.log(data.data)
          this.memberloanplan = data.data
          this.plCategory = this.memberloanplan.disbursement.planCategory
          this.form.disbursement_id = this.memberloanplan.disbursement_id
          this.form.branch_id = this.memberloanplan.branch_id
          this.form.member_id = this.memberloanplan.member_id
          this.form.collection_center_id = this.memberloanplan.collection_center_id
          // console.log('memberloanplans' + this.memberloanplans)
          // this.getSingleMemberLoanDetails()
          this.$axios
          .get('memberemi?all=all&member_loan_plan_id=' + this.memberloanplan.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log('record without date')
            // console.log(data.data)
            this.rows = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
          this.$axios
          .get('membercollection?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log(data.data)
            this.rowsMemberCollections = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
        })
        .catch(function (error) {
          console.log(error)
        })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsMemberCode () {
      this.$axios
      .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
         // alert(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.getSingleMemberLoanDetails()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPlanType () {
      this.form.collection_center_id = ''
      this.form.member_loan_plan_id = ''
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      if (this.form.planType === 'individual') {
        this.collectionCenter = {'name': 'Select Group'}
      }
      if (this.form.planType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
            _.forEach(this.collectionCenters, function (item, key) {
              this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
            }.bind(this))
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
      // this.form.member_id = null
    },
    getGroupLeader () {
     // var x = this.groupMembers
    },
    getMemberAndGroupAndAgent () {
      this.$axios.get('member?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadBank () {
      this.$axios
        .get('bank?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.banks = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadDisbursement () {
      this.$axios
        .get('disbursement?all=all&status=disbursed', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loadDisbursements = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    // this.loadMember();
    this.loadBank()
    // var c = JSON.parse(localStorage.user)
    // if (c.type === 'admin') {
    //   this.loadBranch()
    // }
    this.loadBranch()
    Fire.$on('AfterCreate', () => {
      this.getSingleMemberLoanDetails()
    })
  }
}
</script>



// WEBPACK FOOTER //
// MemberCollection.vue?3dfb53b2